const initialState = []
const replaceMergedTrip = (state, mergedTripId, unmergedTrips) => {
  var newState = []
  state.map( (trip, index) => {
    // find the merged trip index
    if (mergedTripId.indexOf(trip.token_id) > -1) {
      // push the unmerged trips in
      unmergedTrips.forEach(t=> newState.push(t))
    } else {
      newState.push(trip)
    }
  })
  return newState
}

const updateMergedTrip = (array, merged_token_ids, merged_trip) => {
  // Indexes of merged trips
  var indexes = []
  array.map( (item, index) => {
    // Check if merged_token_ids contains the item
    if (merged_token_ids.indexOf(item.token_id) > -1) {
        // Don't return this trip, it's one of the ones we merged
        indexes.push(index)
    }
  })
  // USE MAX: Keep the index of the oldesest trip, the backend saves the newly combined trip with the oldest date of the merged trips
  // .max is not working well, reverting back to min
  var insert_at_index = Math.min(...indexes)

  // Remove merged trips from array
  var newArray = array.filter( (item, index) => !merged_token_ids.includes(item.token_id) );

  // Insert newly merged trip in proper position
  newArray.splice(insert_at_index, 0, merged_trip)

  return newArray
}

const updateTrip = (array, action) => {
  return array.map((trip, index)=>{
    if (trip.token_id === action.trip.token_id) {
      return {
        ...trip,
        ...action.trip,
      }
    }
    return trip
  })
}
const updateTrips = (array, action) => {
  var updated_token_ids = action.trips.map((trip) => trip.token_id)
  return array.map((trip, index)=>{
    if (updated_token_ids.includes(trip.token_id)) {
      return {
        ...trip,
        ...action.trips.filter((updated_trip)=>updated_trip.token_id==trip.token_id)[0],
      }
    }
    return trip
  })
}


export default function trips(state=initialState, action) {
  switch (action.type) {

    case 'GET_TRIPS_SUCCESS':
      return [
        ...action.user.trips
      ]

    case 'LOGIN_SUCCESS':
    case 'USER_SUCCESS':
      const trips = action.user.trips

      return [
        ...state,
        ...trips,
      ]

    case 'LOGOUT_SUCCESS':
      return initialState

    case 'UPDATE_TRIP_SUCCESS':
      return updateTrip(state, action)

    // NOTE: also called from fave places success
    case 'UPDATE_TRIP_BATCH_SUCCESS':
      return updateTrips(state, action)

    case 'GET_MORE_TRIPS_SUCCESS':
      const moreTrips = action.user.trips
      return [
          ...state,
          ...moreTrips
        ]

    case 'CREATE_TRIP_SUCCESS':
      return [
        action.trip,
        ...state
      ]

    case 'REMOVE_TRIP':
      return state.filter(trip=>trip.token_id!==action.trip.token_id)

    case 'MERGE_TRIPS_SUCCESS':
      return updateMergedTrip(state, action.token_ids, action.merged_trip)

    case 'UNDO_MERGE_TRIPS_SUCCESS':
      return replaceMergedTrip(state, action.mergedTripId, action.payload)

    case 'DELETE_TRIPS_SUCCESS':
      return state.filter( trip =>
        !action.token_ids.includes(trip.token_id)
      )

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/models/trips.js